<div [formGroup]="group" [class.form-group]="!group.disabled" class="row align-baseline">
  <!-- label if isEdit  -->
  <label *ngIf="(getControlName.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                || (config.presentation === 'edit' && config.options.labelShowInDetail)"
                class="col-sm-3 control-label" style="white-space: nowrap;">
    {{config.label | translate:locale.language}}
  </label>
  <div class="col-sm-9 parent-container" [class.shortInput]="config?.options?.shortInput">
    <!-- presentation form  -->
    <div *ngIf="(getControlName.disabled && getControlName?.value) || config.presentation === 'detail'" style="width: 100%;">
      <!-- simple -->
      <label style="font-weight: bold;">
        <a href="{{config.linkHref.url}}" target="{{config.linkHref.target}}">{{group.get(config.linkHref.linkName).value}}</a>
      </label>
    </div>
  </div>
</div>

<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <!--  <pre style="flex:1;word-break:break-word;line-height:2;">{{form.get(['subscription', 'network', 'proxy']).value|json}}</pre>-->
  <!--  <pre>enabled:{{getControlName.enabled}}</pre>-->
<!--  <pre>target:{{config.linkHref.target}}</pre>-->
<!--  <pre>linkName:{{config.linkHref.linkName}}</pre>-->
<!--  <pre>show: {{config.options.show}}</pre>-->
<!--  <pre>labelShowInDetail: {{config.options.labelShowInDetail}}</pre>-->
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">value: {{group.value|json}}</pre>-->
</div>
